import React, { FunctionComponent } from 'react';

import { useHistory } from 'react-router-dom';

import Button from '@material-ui/core/Button';

type PrimaryButtonWithRoute = {
  onClick?: never;
  route: '/' | 'story' | 'data' | 'imprint';
};

type PrimaryButtonWithOnClick = {
  onClick: () => void;
  route?: never;
};

type PrimaryButton = (PrimaryButtonWithRoute | PrimaryButtonWithOnClick) & {
  disabled?: boolean;
  tabIndex: number;
};

const PrimaryButton: FunctionComponent<PrimaryButton> = ({
  children,
  disabled,
  onClick,
  route,
  tabIndex,
}) => {
  const { push } = useHistory();

  if (!onClick && route) {
    onClick = () => push(route);
  }

  return (
    <Button
      disabled={disabled}
      variant="contained"
      color="primary"
      onClick={onClick}
      tabIndex={tabIndex}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
